export var DotNavigationAnimation;
(function (DotNavigationAnimation) {
    DotNavigationAnimation["Back"] = "back";
    DotNavigationAnimation["BackNext"] = "back-next";
    DotNavigationAnimation["Forward"] = "forward";
    DotNavigationAnimation["ForwardNext"] = "forward-next";
})(DotNavigationAnimation || (DotNavigationAnimation = {}));
export var DotNavigationTheme;
(function (DotNavigationTheme) {
    DotNavigationTheme["Light"] = "light";
    DotNavigationTheme["Dark"] = "dark";
})(DotNavigationTheme || (DotNavigationTheme = {}));
export var DotNavigationDataKeys;
(function (DotNavigationDataKeys) {
    DotNavigationDataKeys["ShowBorder"] = "data-show-border";
    DotNavigationDataKeys["Theme"] = "data-theme";
    DotNavigationDataKeys["SavedCurrentIndex"] = "data-current";
})(DotNavigationDataKeys || (DotNavigationDataKeys = {}));
export var DotNavigationDataHooks;
(function (DotNavigationDataHooks) {
    DotNavigationDataHooks["Dot"] = "dot";
    DotNavigationDataHooks["Input"] = "hidden-radio";
})(DotNavigationDataHooks || (DotNavigationDataHooks = {}));
//# sourceMappingURL=types.js.map